module.exports = __webpack_public_path__ + "static/img/03-3.39143db.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/issue11/01/03-3.jpg
// module id = MyTI
// module chunks = 7